//SingleBlogPost.js
///////////////////////////////
//React & Material
import React from 'react';
import { Badge, Image, Row } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
//Plugins
import styled from 'styled-components';
import ProfilePic from '../media/blogs/profilePic.jpg';

//Component Imports

//////////////////////////////
//Styled components


const ImgWrapper = styled(Image)`
object-fit: cover;
// width: 300px;
object-fit: cover;
width: 416px;
height: 297px;
border-radius: 36px;
`

const BlogTitle = styled.h5`
text-align:left;
font-weight:bold;
margin-bottom:22px;
line-height:30px;
`

const Description = styled.p`
  text-align:left;
  line-height:25px;
  &:hover{
    color:white;
  }

color: rgba(255, 255, 255, 0.35);
`

const Author = styled.div
  `
margin-top:15px;
align-items:flex-end;
display:flex;
flex-direction:row;
justify-content:center;
`


const CustomBadge = styled(Badge)`
  background:#36FFC1;
  color:#00553B;
  padding:5px 15px 5px 15px;
  font-weight:bold;
  margin-bottom:15px;
`
const CustomBadgeDate = styled(Badge)`
  border: 1px solid #36FFC1;
  background:black;
  color:#36FFC1;
  padding:5px 15px 5px 15px;
  font-weight:bold;
  margin-bottom:15px;
  margin-left:15px;
`
const Profile = styled(Image)`
  height:50px;

`
const AuthorDetails = styled.div`
  display:flex;
  align-items:flex-start;
  flex-direction:column;
  margin-left:20px;
  // justify-content:center;
`

const AuthorTitle = styled.h6`
  font-weight:bold;
  line-height:10px;
  margin-bottom:8px;
`

const AuthorDesign = styled.p`
&:hover{
  color:white;
}

color: rgba(255, 255, 255, 0.35);
margin-bottom:0;
`


const CustomLink = styled.a`
text-decoration: none;


-webkit-transition: color 1s ease-out;
-moz-transition: color 1s ease-out;
-o-transition: color 1s ease-out;
-ms-transition: color 1s ease-out;
transition: color 1s ease-out;
    &:focus, &:visited, &:link, &:active {
        text-decoration: none;
        color:inherit;
    }
    &:hover{
      text-decoration: none;
      color:#36FFC1;
    }

 
  
  
    
`

const MainWrapper = styled(Container)`
    flex-direction:column;
    justify-content:flex-start;
    align-items:flex-start;
    margin-bottom:60px;
`

const ImageRow = styled(Row)`

`

const TagRow = styled(Row)`
    align-items:flex-start;
    margin-top:20px;
`

const TitleRow = styled(Row)`

`

const InfoRow = styled(Row)`

`
//////////////////////////////
//Component class
/**
 * Displays a template component
 */
function SingleBlogPost(props) {

  const data = props.content;

  const RenderSingle = () => {
    return (
      <CustomLink href={data.link} target="_blank" rel="noopener noreferrer">
        <MainWrapper>
          <ImageRow>
            <ImgWrapper src={require(`../media/blogs/`+data.imageLink)} fluid />
          </ImageRow>
          <TagRow>
              <CustomBadge variant="info">{data.topicTag}</CustomBadge>
              <CustomBadgeDate variant="info">{data.datePublished}</CustomBadgeDate>
          </TagRow>
          <TitleRow>
            <BlogTitle>{data.headline}</BlogTitle>
          </TitleRow>
          <InfoRow>
            <Description>
              {data.desc}
            </Description>
          </InfoRow>
          <Row>
            <Author>
              <Profile src={ProfilePic} fluid roundedCircle />
              <AuthorDetails>
                <AuthorTitle>Gayuru Gunawardena</AuthorTitle>
                <AuthorDesign>
                  Lead Author
                </AuthorDesign>
              </AuthorDetails>
            </Author>
          </Row>
        </MainWrapper>
      </CustomLink>
    )
  }

  return (
    <RenderSingle />
  )
}
export default SingleBlogPost;